import { BUSINESS_SCHEMA, USER_SCHEMA, INAPP_SCHEMA, CUSTOMER_SCHEMA, INVOICE_SCHEMA, GROUP_CUSTOMER_SCHEMA, GROUP_PAYMENT_SCHEMA, GROUP_SCHEMA, CUSTOMER_ACCOUNTS_SCHEMA, CONTACTS_SCHEMA, GROUP_PAYMENT_LEDGER_SCHEMA, ANALYTICS_EVENTS_SCHEMA, TRUSTED_LIST_SCHEMA, SURVEY_RESPONSES_SCHEMA, WISHLIST_SCHEMA, WISHLIST_ITEMS_SCHEMA, GUIDED_TOURS_SCHEMA, NOTIFICATIONS_SCHEMA, NUDGE_SCHEMA, RATE_LIST_SCHEMA, RATE_LIST_LINES_SCHEMA, SIGNATURES_SCHEMA, CASHBOOK_CATEGORIES, COMPANY, INVENTORY_SCHEMA, STOCK_SCHEMA, PAYMENT_SCHEMA, CASH_TXN_SCHEMA } from './schema'
import { schemaMigrations, createTable, addColumns, unsafeExecuteSql } from '@nozbe/watermelondb/Schema/migrations'

export default schemaMigrations({
    migrations: [

        {
            toVersion: 38,
            steps: [
                addColumns({

                    table: INVENTORY_SCHEMA,

                    columns: [
                        { name: 'order_id', type: 'string', isOptional: true },

                        { name: 'refrence_id', type: 'string', isOptional: true },

                        { name: 'table_name', type: 'string', isOptional: true },

                        { name: 'tran_type', type: 'string', isOptional: true },

                    ]

                }),
                addColumns({
                    table: BUSINESS_SCHEMA,
                    columns: [
                        { name: 'cashbook_migrated', type: 'boolean', isOptional: true },

                    ],
                }),
                unsafeExecuteSql(`
                    create index if not exists "cash_txn_business_id" on "cash_txn" ("business_id");
                    create index if not exists "cash_txn_transacted_at" on "cash_txn" ("transacted_at");
                    create index if not exists "cash_txn_type" on "cash_txn" ("type");
                    create index if not exists "cash_txn_business_transacted_covering" on "cash_txn" ("business_id", "transacted_at", "amount", "type", "_status");
                `),
                unsafeExecuteSql(`
                    create index if not exists "invoice_business_id" on "invoice" ("business_id");
                    create index if not exists "invoice_transacted_at" on "invoice" ("transacted_at");
                    create index if not exists "invoice_type" on "invoice" ("type");
                    create index if not exists "invoice_business_type_transacted_covering" on "invoice" ("business_id", "type", "transacted_at");
                    create index if not exists "orders_invoice_id" on "orders" ("invoice_id");
                `),
                addColumns({
                    table: GROUP_PAYMENT_LEDGER_SCHEMA,
                    columns: [
                        { name: 'attachment', type: 'string', isOptional: true },
                    ],
                }),
                addColumns({
                    table: CUSTOMER_SCHEMA,
                    columns: [
                        { name: 'is_personal', type: 'boolean' },
                    ],
                }),

            ],
        },

        {
            toVersion: 37,
            steps: [
                createTable({
                    name: CASH_TXN_SCHEMA,
                    columns: [
                        { name: 'business_id', type: 'string' },
                        { name: 'customer_id', type: 'string', isOptional: true },
                        { name: 'sales_amount', type: 'number', isOptional: true },
                        { name: 'cost_amount', type: 'number', isOptional: true },
                        { name: 'amount', type: 'number' },
                        { name: 'transacted_at', type: 'number' },
                        { name: 'image_url', type: 'string', isOptional: true },
                        { name: 'note', type: 'string', isOptional: true },
                        { name: 'status', type: 'string', isOptional: true },
                        { name: 'tranType', type: 'string', isOptional: true },
                        { name: 'method', type: 'string', isOptional: true },
                        { name: 'type', type: 'string' },
                        { name: 'bank', type: 'string', isOptional: true },
                        { name: 'wallet', type: 'string', isOptional: true },
                        { name: 'category', type: 'string', isOptional: true },
                        { name: 'recording', type: 'string', isOptional: true },
                        { name: 'is_synced', type: 'boolean' },
                        { name: 'total', type: 'number' },
                        { name: 'sub_total', type: 'number' },
                        { name: 'discount', type: 'number' },
                        { name: 'discount_unit', type: 'string' },
                        { name: 'tax_title', type: 'string' },
                        { name: 'tax_rate', type: 'number' },
                        { name: 'advance_amount', type: 'number' },
                        { name: 'invoice_title', type: 'string' },
                        { name: 'invoice_number', type: 'string' },
                        { name: 'attachment', type: 'string', isOptional: true },
                        { name: 'invoice_prefix', type: 'string', isOptional: true },
                        { name: 'signature', type: 'string', isOptional: true },
                        { name: 'profit', type: 'number', isOptional: true },
                        { name: 'document_url', type: 'string', isOptional: true },
                        { name: 'created_at', type: 'number' },
                        { name: 'wallet_txns_id', type: 'string', isOptional: true },
                    ]
                }),
                addColumns({
                    table: PAYMENT_SCHEMA,
                    columns: [
                        { name: 'cash_txn_id', type: 'string', isOptional: true },
                    ]
                }),

            ]
        },
        {
            toVersion: 36,
            steps: [
                addColumns({
                    table: INVOICE_SCHEMA,
                    columns: [
                        { name: "reference_id", type: "string", isOptional: true },
                        { name: "change_amount", type: "number" },
                        { name: "due_date", type: "number" },
                    ]
                }),
                addColumns({
                    table: STOCK_SCHEMA,
                    columns: [
                        { name: "sku", type: "string", isOptional: true },
                    ]
                }),
                addColumns({
                    table: PAYMENT_SCHEMA,
                    columns: [
                        { name: "category", type: "string", isOptional: true },
                        { name: "attachment", type: "string", isOptional: true },
                    ]
                })
            ]
        },
        {
            toVersion: 35,
            steps: [
                addColumns({
                    table: BUSINESS_SCHEMA,
                    columns: [
                        { name: "quick_sale_number_count", type: "number" },
                    ]
                })
            ]
        },
        {
            toVersion: 34,
            steps: [
                addColumns({
                    table: USER_SCHEMA,
                    columns: [
                        { name: 'alternate_number', type: 'string', isOptional: true }
                    ]
                }),
                addColumns({
                    table: BUSINESS_SCHEMA,
                    columns: [
                        { name: "expense_number_count", type: "number" },
                    ]
                }),
                addColumns({
                    table: CUSTOMER_SCHEMA,
                    columns: [
                        { name: 'collection_set_at', type: 'number', isOptional: true },
                        { name: 'reminder_type', type: 'string', isOptional: true },
                        { name: "payment_at", type: "number", isOptional: true },
                        { name: 'image_url', type: 'string', isOptional: true },
                        { name: 'viewed_at', type: 'number', isOptional: true },
                        { name: 'web_link', type: 'string', isOptional: true },
                        { name: 'email', type: 'string', isOptional: true },
                    ]
                }),
                addColumns({
                    table: INVOICE_SCHEMA,
                    columns: [
                        { name: "company_id", type: "string", isOptional: true },
                        { name: 'signatures_id', type: 'string' },
                    ]
                }),
                addColumns({
                    table: CONTACTS_SCHEMA,
                    columns: [
                        { name: 'customer_id', type: 'string', isOptional: true },
                        { name: 'hash', type: 'string' },
                    ]
                }),
                addColumns({
                    table: INAPP_SCHEMA,
                    columns: [
                        { name: 'description_json', type: 'string', isOptional: true },
                    ]
                }),
                addColumns({
                    table: INVENTORY_SCHEMA,
                    columns: [
                        { name: 'price', type: 'number', isOptional: true },
                        { name: 'is_secondary_unit', type: 'boolean', isOptional: true },
                        { name: 'unit_conversion', type: 'number', isOptional: true }
                    ]
                }),
                createTable({
                    name: CASHBOOK_CATEGORIES,
                    columns: [
                        { name: 'business_id', type: 'string' },
                        { name: 'name', type: 'string' }
                    ]
                }),
                createTable({
                    name: COMPANY,
                    columns: [
                        { name: 'business_id', type: 'string' },
                        { name: 'name', type: 'string' }
                    ]
                }),
                createTable({
                    name: GROUP_SCHEMA,
                    columns: [
                        { name: 'group_type', type: 'string', isOptional: true },
                        { name: 'image_url', type: 'string', isOptional: true },
                        { name: 'payment_received', type: 'number' },
                        { name: 'business_id', type: 'string' },
                        { name: 'collect_at', type: 'number' },
                        { name: 'amount', type: 'number' },
                        { name: 'count', type: 'number' },
                        { name: 'name', type: 'string' },
                        { name: 'type', type: 'string' },
                    ]
                }),
                createTable({
                    name: GROUP_PAYMENT_SCHEMA,
                    columns: [
                        { name: 'processed', type: 'boolean' },
                        { name: 'collect_at', type: 'number' },
                        { name: 'group_id', type: 'string' },
                        { name: 'amount', type: 'number' },
                        { name: 'type', type: 'string' },
                    ]
                }),
                createTable({
                    name: GROUP_CUSTOMER_SCHEMA,
                    columns: [
                        { name: 'total_outstanding_payment', type: 'number' },
                        { name: 'customer_id', type: 'string' },
                        { name: 'group_id', type: 'string' },
                    ]
                }),
                createTable({
                    name: CUSTOMER_ACCOUNTS_SCHEMA,
                    columns: [
                        { name: 'account_number', type: 'string' },
                        { name: 'customer_id', type: 'string' },
                        { name: 'title', type: 'string' },
                        { name: 'bank', type: 'string' },
                        { name: 'type', type: 'string' }
                    ]
                }),
                createTable({
                    name: GROUP_PAYMENT_LEDGER_SCHEMA,
                    columns: [
                        { name: 'image_url', type: 'string', isOptional: true },
                        { name: 'recording', type: 'string', isOptional: true },
                        { name: 'group_id', type: 'string', isOptional: true },
                        { name: 'wallet', type: 'string', isOptional: true },
                        { name: 'method', type: 'string', isOptional: true },
                        { name: 'type', type: 'string', isOptional: true },
                        { name: 'note', type: 'string', isOptional: true },
                        { name: 'bank', type: 'string', isOptional: true },
                        { name: 'group_payment_id', type: 'string' },
                        { name: 'transacted_at', type: 'number' },
                        { name: 'payment_mode', type: 'string' },
                        { name: 'business_id', type: 'string' },
                        { name: 'customer_id', type: 'string' },
                        { name: 'created_at', type: 'number' },
                        { name: 'amount', type: 'number' },
                    ]
                }),
                createTable({
                    name: TRUSTED_LIST_SCHEMA,
                    columns: [
                        { name: 'type', type: 'string', isOptional: true },
                        { name: 'business_id', type: 'string' },
                        { name: 'number', type: 'string' },
                        { name: 'name', type: 'string' },
                    ]
                }),
                createTable({
                    name: ANALYTICS_EVENTS_SCHEMA,
                    columns: [
                        { name: 'updated_at', type: 'number' },
                        { name: 'is_fired', type: 'boolean' },
                        { name: 'user_id', type: 'string' },
                        { name: 'count', type: 'number' },
                        { name: 'name', type: 'string' },
                    ]
                }),
                createTable({
                    name: SURVEY_RESPONSES_SCHEMA,
                    columns: [
                        { name: 'secondary_answer', type: 'string', isOptional: true },
                        { name: 'business_id', type: 'string' },
                        { name: 'question', type: 'string' },
                        { name: 'options', type: 'string' },
                        { name: 'answer', type: 'string', },
                        { name: 'type', type: 'string' },
                    ]
                }),
                createTable({
                    name: WISHLIST_SCHEMA,
                    columns: [
                        { name: 'created_at', type: 'number' },
                        { name: 'user_id', type: 'string' },
                    ]
                }),
                createTable({
                    name: WISHLIST_ITEMS_SCHEMA,
                    columns: [
                        { name: 'variant_id', type: 'number', isOptional: true },
                        { name: 'wishlist_id', type: 'string' },
                        { name: 'product_id', type: 'number', },
                    ]
                }),
                createTable({
                    name: NOTIFICATIONS_SCHEMA,
                    columns: [
                        { name: 'supplier_id', type: 'string', isOptional: true },
                        { name: 'web_slug', type: 'string', isOptional: true },
                        { name: 'supplier_order_number', type: 'number' },
                        { name: 'customer_order_number', type: 'number' },
                        { name: 'sync_timestamp_unix', type: 'number' },
                        { name: 'supplier_image', type: 'string', },
                        { name: 'session_key', type: 'string' },
                        { name: 'created_at', type: 'number' },
                        { name: 'btn_title', type: 'string' },
                        { name: 'cta_color', type: 'string' },
                        { name: 'btn_color', type: 'string' },
                        { name: 'btn_icon', type: 'string' },
                        { name: 'supplier', type: 'string' },
                        { name: 'user_id', type: 'string' },
                        { name: 'favicon', type: 'string' },
                        { name: 'message', type: 'string' },
                        { name: 'status', type: 'string' },
                        { name: 'title', type: 'string' },
                        { name: 'type', type: 'string' },
                    ]
                }),
                createTable({
                    name: NUDGE_SCHEMA,
                    columns: [
                        { name: 'total_step_count', type: 'number' },
                        { name: 'completed_count', type: 'number' },
                        { name: 'completed_steps', type: 'string' },
                        { name: 'user_id', type: 'string' },
                        { name: 'name', type: 'string' },
                    ]
                }),
                createTable({
                    name: GUIDED_TOURS_SCHEMA,
                    columns: [
                        { name: 'completed_steps', type: 'string' },
                        { name: 'sub_module', type: 'string' },
                        { name: 'updated_at', type: 'number' },
                        { name: 'step_name', type: 'string' },
                        { name: 'user_id', type: 'string' },
                        { name: 'module', type: 'string' },
                    ]
                }),
                createTable({
                    name: RATE_LIST_SCHEMA,
                    columns: [
                        { name: 'validity', type: 'number', isOptional: true },
                        { name: 'rate_list_name', type: 'string' },
                        { name: 'business_id', type: 'string' },
                        { name: 'created_at', type: 'number' },
                        { name: 'updated_at', type: 'number' },
                    ]
                }),
                createTable({
                    name: RATE_LIST_LINES_SCHEMA,
                    columns: [
                        { name: 'minimum_order_quantity', type: 'number', isOptional: true },
                        { name: 'is_secondary_unit', type: 'boolean', isOptional: true },
                        { name: 'unit_conversion', type: 'number', isOptional: true },
                        { name: 'discount_method', type: 'string', isOptional: true },
                        { name: 'secondary_unit', type: 'string', isOptional: true },
                        { name: 'transacted_at', type: 'number', isOptional: true },
                        { name: 'selling_price', type: 'number', isOptional: true },
                        { name: 'rate_list_id', type: 'string', isOptional: true },
                        { name: 'inclusive', type: 'boolean', isOptional: true },
                        { name: 'cost_price', type: 'number', isOptional: true },
                        { name: 'stock_id', type: 'string', isOptional: true },
                        { name: 'tran_type', type: 'string', isOptional: true },
                        { name: 'discount', type: 'number', isOptional: true },
                        { name: 'type', type: 'string', isOptional: true },
                        { name: 'unit', type: 'string', isOptional: true },
                        { name: 'tax', type: 'number', isOptional: true },
                        { name: 'business_id', type: 'string' },
                        { name: 'quantity', type: 'number' },
                        { name: 'name', type: 'string' },
                    ]
                }),
                createTable({
                    name: SIGNATURES_SCHEMA,
                    columns: [
                        { name: 'updated_at', type: 'number' },
                        { name: 'created_at', type: 'number' },
                        { name: 'sign_url', type: 'string' },
                        { name: 'user_id', type: 'string' },
                    ]
                }),
            ]
        },
        { toVersion: 33, steps: [] },
        { toVersion: 32, steps: [] },
        { toVersion: 31, steps: [] },
        { toVersion: 30, steps: [] },
        { toVersion: 29, steps: [] },
        { toVersion: 28, steps: [] },
        { toVersion: 27, steps: [] },
        { toVersion: 26, steps: [] },
        { toVersion: 25, steps: [] },
        { toVersion: 24, steps: [] },
        { toVersion: 23, steps: [] },
        { toVersion: 22, steps: [] },
        { toVersion: 21, steps: [] },
        { toVersion: 20, steps: [] },
        { toVersion: 19, steps: [] },
        { toVersion: 18, steps: [] },
        { toVersion: 17, steps: [] },
        { toVersion: 16, steps: [] },
        { toVersion: 15, steps: [] },
    ],
})